import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ru from "vuetify/src/locale/ru.ts"
import NextStage from "@/icons/NextStage.vue"
import PrevStage from "@/icons/PrevStage.vue"
import RadioOn from "@/icons/RadioOn.vue"
import RadioOff from "@/icons/RadioOff.vue"
import CheckboxOn from "@/icons/CheckboxOn.vue"
import CheckboxOff from "@/icons/CheckboxOff.vue"
import PrevStageHover from "@/icons/PrevStageHover.vue"
import NextStageHover from "@/icons/NextStageHover.vue"
import Phone from "@/icons/Phone.vue"

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: {ru},
    current: 'ru',
  },
  icons: {
    iconfont: 'mdiSvg',
    values: {
      nextStage: {
        component: NextStage
      },
      nextStageHover: {
        component: NextStageHover
      },
      prevStage: {
        component: PrevStage
      },
      prevStageHover: {
        component: PrevStageHover
      },
      radioOn: {
        component: RadioOn
      },
      radioOff: {
        component: RadioOff
      },
      checkboxOn: {
        component: CheckboxOn
      },
      checkboxOff: {
        component: CheckboxOff
      },
      phone: {
        component: Phone
      }
    }
  },
  theme: {
    themes: {
      light: {
        primary: '#2A3948'
      }
    }
  }
})